import React, { useState } from 'react';

// Função atualizada para ser mais robusta
const getFirstNameFromEmail = (email) => {
  if (!email) return 'Usuário';
  const namePart = email.split('@')[0];
  const firstName = namePart.split(/[._-]/)[0];
  return firstName.charAt(0).toUpperCase() + firstName.slice(1);
};

function CommentsModal({ isOpen, onClose, task, onAddComment }) {
  const [newComment, setNewComment] = useState('');

  if (!isOpen || !task) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newComment.trim() === '') return;
    onAddComment(task.etapaId, task.id, newComment);
    setNewComment('');
  };

  const sortedComments = task.comments ? [...task.comments].sort((a, b) => a.timestamp - b.timestamp) : [];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content comments-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Comentários da Tarefa</h2>
        <p className="comment-task-title">{task.text}</p>
        
        <div className="comments-list">
          {sortedComments.length > 0 ? (
            sortedComments.map((comment, index) => {
              // --- LÓGICA DE NOME ATUALIZADA ---
              // 1. Tenta usar o userName.
              // 2. Se não existir, usa o userEmail para extrair o nome.
              const authorName = comment.userName || getFirstNameFromEmail(comment.userEmail);

              return (
                <div key={index} className="comment-bubble-wrapper">
                  <div className="comment-bubble">
                    <div className="comment-header">
                      <span className="comment-author">{authorName}</span>
                    </div>
                    <p className="comment-text">{comment.text}</p>
                    <div className="comment-footer">
                      <span className="comment-date">
                        {new Date(comment.timestamp).toLocaleTimeString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="no-comments">Nenhum comentário ainda.</p>
          )}
        </div>

        <div className="comment-form-container">
          <form onSubmit={handleSubmit}>
            <textarea
              placeholder="Adicionar um comentário..."
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
              required
            ></textarea>
            <button type="submit">Publicar</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CommentsModal;